import supabase from "../../supabase/supabase";

const PAGE_SIZE = 1000;

const TRANSACTION_SELECT = `
  id,
  organization_id,
  account_id,
  batch_id,
  date,
  description,
  debit,
  credit,
  source,
  status,
  created_by,
  created_at,
  updated_at,
  account:accounts!transactions_account_id_fkey (
    id,
    code,
    name,
    type
  )
`;

function requireOrganization(organizationId) {
  if (!organizationId) {
    throw new Error("Select a business to view its transactions.");
  }

  return organizationId;
}

export const clientTransactionService = {
  async getClientTransactions(organizationId) {
    const organization = requireOrganization(organizationId);

    const [accountResult, transactionRows] = await Promise.all([
      supabase
        .schema("accounting")
        .from("accounts")
        .select("id,organization_id,code,name,type,is_active")
        .eq("organization_id", organization)
        .eq("is_active", true)
        .order("code", { ascending: true })
        .order("name", { ascending: true })
        .then(({ data, error }) => {
          if (error) throw error;
          return data || [];
        }),

      this.getAllTransactionRows(organization),
    ]);

    const transactions = transactionRows.map((row) => ({
      ...row,
      account: Array.isArray(row.account)
        ? row.account[0] || null
        : row.account || null,
    }));

    return {
      transactions,
      accounts: accountResult,
    };
  },

  async getAllTransactionRows(organizationId) {
    const rows = [];
    let offset = 0;

    while (true) {
      const { data, error } = await supabase
        .schema("accounting")
        .from("transactions")
        .select(TRANSACTION_SELECT)
        .eq("organization_id", organizationId)
        .order("date", { ascending: false })
        .order("created_at", { ascending: false })
        .range(offset, offset + PAGE_SIZE - 1);

      if (error) throw error;

      const page = data || [];
      rows.push(...page);

      if (page.length < PAGE_SIZE) break;
      offset += PAGE_SIZE;
    }

    return rows;
  },
};